interface KpiGridProps {
  children: React.ReactNode;
}

export function KpiGrid({ children }: KpiGridProps) {
  return (
    <div className="grid grid-cols-3 gap-3 lg:grid-cols-5">
      {children}
    </div>
  );
}
